import React from 'react';
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon';
import { Twitter, Instagram } from '@material-ui/icons';
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { useDispatch } from "react-redux";
import { addToCart } from "../../actions"

export default function () {
	//const currentPoster = useSelector(state => state.poster);
	const dispatch = useDispatch();

	const handleClick = (mode) => {
		if (mode) {
			dispatch(addToCart({ poster: null, format: 'digital', id: 3, price: 5, title: "Gift Card", category: "giftcard" }));
		} else {
			dispatch(addToCart({ poster: null, format: 'paper', id: 4, price: 35, title: "Gift Card", category: "giftcard" }));
		}
	};


	let legend = ["Grid Map", "Single/Multiple Routes Map", "Calendar", "Details"]
	return (
		<div id="splash" style={{ fontFamily:'sans-serif', display: 'flex', flexDirection: 'column', alignItems: "center", marginTop: 60, justifyContent: "center" }}>
			<div style={{ width: '100%', height: 300, backgroundPosition: 'left center', backgroundRepeat: 'no-repeat', backgroundImage: 'url("img/bg.jpg")', backgroundColor: '#2c2c2c' }}>
				<div style={{ position: 'relative', float: 'right', marginRight: 60, marginBottom: 10, marginTop: 60, width: 700, background: 'radial-gradient(rgba(44, 44, 44, 1), rgba(44, 44, 44, 0))' }}>
					<h1 style={{ color: '#FEFEFE', marginTop: 30, marginBottom: 0, textAlign: 'center' }}>Turn your sport activities into art</h1>
					<h2 style={{ color: '#CCC', marginTop: 10, marginBottom: 30, textAlign: 'center' }}>... and exhibit your best achievements!</h2>
					<Button component={Link} to='/editor' variant="contained" color="primary" style={{ width: 155, marginBottom: 0, marginLeft: 272 }}>Start now!</Button >
					<br />
					<div style={{ width: '100%', textAlign: 'center' }}>
						<span style={{ width: '100%', color: '#AAA', fontSize: 11 }}>* A <a style={{ width: '100%', color: '#FFF', fontSize: 11 }} target='_blank' rel="noopener noreferrer" href='https://www.strava.com'>Strava</a> account is required </span>
					</div>
				</div>


			</div>

			<div style={{
				height: '90px', width: '100%', backgroundColor: '#222', color: '#DDD',
				display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-between'
			}}>
				<div style={{ width: '15%' }} />
				<div style={{ textAlign: 'center' }}>
					<Icon style={{ fontSize: 42, marginTop: 10 }}>dashboard</Icon><br />
					Multiple designs {/* or templates (Single route map, multi-routes map, grid, calendar, heatmap, circular)*/}
				</div>
				<div style={{ textAlign: 'center' }}>
					<Icon style={{ fontSize: 42, marginTop: 10 }}>palette</Icon><br />
					Different themes {/*(light, dark)*/}
				</div>
				<div style={{ textAlign: 'center' }}>
					<Icon style={{ fontSize: 42, marginTop: 10 }}>edit</Icon><br />
					Easy to customize {/*(labels, color, layout)*/}
				</div>
				<div style={{ width: '15%' }} />
			</div>
			<br /><br /><br />
			<Typography variant="h4" gutterBottom>
				# Your art for your home
			</Typography>
			<Typography variant="subtitle1" gutterBottom>
				No matter how big or small your achievements are, you should be proud of what you've accomplished.
			</Typography>
			<br /><br />
			<div style={{ overflowX: 'hidden', padding: 8 }}>

				<Grid container justify="center" spacing={2}>
					{[1, 2, 3, 5].map((value, i) => (
						<Grid key={value} align="center" item>
							<img alt="" style={{ border: '1px solid black' }} height='400' src={'img/' + value + '.png'} /><br />
							<Typography variant="subtitle1" gutterBottom>
								{legend[i]}
							</Typography>
						</Grid>
					))}
				</Grid>
			</div><br />
			<Button component={Link} to='/editor' variant="contained" color="primary" style={{ width: 200 }}>Create your own</Button >

			<br /><br /><br />
			<div style={{ width: '100%', overflowX: 'hidden', backgroundColor: '#222', flexGrow: 1, paddingTop: 100 }}>
				<Grid container justify="center" spacing={0} >
					<Grid item >
						<img style={{ verticalAlign: 'text-bottom', marginBottom: 0, paddingBottom: 0 }} alt="" src={'img/cut.png'} />
					</Grid>
					<Grid item >
						<div style={{ marginLeft: 50, width: 400 }}>
							<Typography variant="h4" gutterBottom style={{ color: '#fff' }}>
								# The Art Of Exercise
							</Typography>
							<Typography variant="subtitle1" gutterBottom style={{ color: '#bbb' }}>
								Every day we train with grit and determination. Now it's time to stand tall and be proud of what we've achieved; the hills we've climbed, the segments we've conquered and the PBs we've smashed.
								<br /><br />
								Cartorion allows you to connect your Strava account to design beautiful, bespoke prints to hang on your wall at home, in all their glory.
							</Typography>
							<br />
							<Button component={Link} to='/editor' variant="contained" color="primary">Get started</Button >
						</div>
					</Grid>
				</Grid>
			</div>
			<div style={{ width: '100%', overflowX: 'hidden', backgroundPosition: 'left center', backgroundRepeat: 'no-repeat', backgroundImage: 'url("img/bg_giftcard.jpg")', backgroundColor: '#e5e5e5', textAlign: 'center', flexGrow: 1, paddingTop: 150, paddingBottom: 150, borderBottom: '1px solid #eee' }}>


				<Grid container justify="center" spacing={4} >

					<Grid item >
						<div>
							<Typography variant="h4" gutterBottom>
								# Gift card
							</Typography><Icon style={{ fontSize: 42 }}>redeem</Icon>
							<Typography variant="subtitle1" gutterBottom>

								The perfect gift to offer to your sportive friends.<br />

							</Typography>
						</div>
						<Grid item >
							<Button onClick={() => handleClick(1)} variant="contained" color="primary" style={{ width: 200 }}> Digital Format | $5 <br /> Add to cart</Button >&nbsp;&nbsp;
							<Button onClick={() => handleClick(0)} variant="contained" color="primary" style={{ width: 200 }}>Paper Format | $35 <br /> Add to cart</Button >
						</Grid>
						<span style={{ color: '#aaa', fontSize: 14, paddingTop: 30 }}><br />*Receive an e-mail with a nice "print-ready" PDF file including a unique promo code</span>
					</Grid>

				</Grid>
			</div>

			<div style={{ width: '100%', height: '550px', overflowX: 'hidden', backgroundPosition: 'top center', backgroundRepeat: 'no-repeat', backgroundImage: 'url("img/freedownload.png")', backgroundColor: '#222', textAlign: 'center', flexGrow: 1, paddingTop: 0, paddingBottom: 0, borderTop: '1px solid #222', borderBottom: '1px solid #222' }}>
				<div style={{ paddingTop: '140px' }}>
					<Typography variant="h4" gutterBottom style={{ color: '#222' }}>
						# Free download
					</Typography>
					<Typography variant="subtitle1" gutterBottom style={{ color: '#666' }}>
						to share with your friends and family <br />or on your favorite social media...
					</Typography>
					<Twitter style={{ fontSize: 42, color: '#666' }}></Twitter>&nbsp;
					<Instagram style={{ fontSize: 42, color: '#666' }}></Instagram>&nbsp;
					<Icon style={{ fontSize: 42, color: '#666' }}>facebook</Icon>
				</div>
			</div>
			<br /><br /><br />
			<Typography variant="h3" gutterBottom>
				# Gallery
			</Typography>
			<Typography variant="subtitle1" gutterBottom style={{ color: '#666' }}>
				Get an idea of what can be done
			</Typography>
			<br />
			<div style={{ flexGrow: 1, padding: 8 }}>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='356' src={'img/mockup/mockup1.png'} />
					</Grid>
					<Grid item>
						<img alt="" height='356' src={'img/mockup/mockup7.png'} />
					</Grid>
				</Grid>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='350' src={'img/mockup/mockup10.png'} />
					</Grid>
					<Grid item>
						<img alt="" height='350' src={'img/mockup/mockup5.png'} />
					</Grid>
				</Grid>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='364' src={'img/mockup/mockup2.png'} />
					</Grid>
				</Grid>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='358' src={'img/mockup/mockup8.png'} />
					</Grid>
					<Grid item>
						<img alt="" height='358' src={'img/mockup/mockup6.png'} />
					</Grid>
				</Grid>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='686' src={'img/mockup/mockup3.png'} />
					</Grid>
				</Grid>
				<Grid container justify="center" spacing={2}>
					<Grid item>
						<img alt="" height='404' src={'img/mockup/mockup4.png'} />
					</Grid>
					<Grid item>
						<img alt="" height='404' src={'img/mockup/mockup9.png'} />
					</Grid>
				</Grid>

			</div>
			<br />
			<div style={{
				height: '100px', width: '100%', backgroundColor: '#222', color: '#DDD',
				display: 'flex', flexFlow: 'row wrap', justifyContent: 'space-between'
			}}>
				<div style={{ width: '100%', textAlign: 'center', marginTop: 20, color: '#aaa' }}>
					&copy; Copyright 2019-{new Date().getFullYear()} | Cartorion <br />
					<img alt='Compatible with Strava' src='img/api_logo_cptblWith_strava_horiz_white.png' width='250' />
				</div>
			</div>
		</div >
	)
}


// WEBPACK FOOTER //
// ./src/components/website/Home.js